import styler, { Styler } from 'stylefire';
import physics from 'popmotion/animations/physics';
import React, { PureComponent } from 'react';
import value, { ValueReaction } from 'popmotion/reactions/value';
import { Action } from 'popmotion/action';
import { ColdSubscription } from 'popmotion/action/types';
import { DesktopWrapper, MobileWrapper, TabletWrapper, InnerWrapper } from './MenuWrapper.s';
import { MenuContent } from './Content';
import { Sizes } from 'module/View/Common';
import Scrollbars from 'react-custom-scrollbars';

type AnimatedValues = {
  translateX: number;
};

type Props = {
  windowWidth: number;
  windowHeight: number;
  adminBarHeight: number;
  toggle: () => void;
  open: boolean;
  mounted: boolean;
};

export class MenuWrapper extends PureComponent<Props> {
  private wrapperRef: HTMLElement | null = null;
  private activeAction: ColdSubscription;
  private action: Action;
  private translateValue: ValueReaction;
  private elemStyler: Styler;

  constructor(props: Props) {
    super(props);
    this.registerRef = this.registerRef.bind(this);
    this.applyTranslateValue = this.applyTranslateValue.bind(this);
    this.getMenuTranslate = this.getMenuTranslate.bind(this);

    this.translateValue = value({ translateX: -Sizes.getMenuWidth(props.windowWidth) }, this.applyTranslateValue);
    this.action = physics({
      velocity: this.translateValue.getVelocity(),
      friction: 0.95,
      springStrength: 200,
      to: this.translateValue.get(),
      restSpeed: false,
    });
    this.activeAction = this.action.start(this.translateValue);
    // debug
    if (this.activeAction && this.activeAction.stop) {
      (window as any).stopMenu = this.activeAction.stop;
    }
    if (this.activeAction.set) {
      this.activeAction.set({ translateX: this.getMenuTranslate(props) });
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.activeAction.setSpringTarget) {
      this.activeAction.setSpringTarget({ translateX: this.getMenuTranslate(nextProps) });
    }
  }

  render() {
    const { adminBarHeight, windowWidth, windowHeight, mounted } = this.props;
    const layout = Sizes.getMenuLayout(windowWidth);
    const Wrapper = (() => {
      switch (layout) {
        case Sizes.MenuLayout.Desktop:
          return DesktopWrapper;
        case Sizes.MenuLayout.Tablet:
          return TabletWrapper;
        case Sizes.MenuLayout.Mobile:
          return MobileWrapper;
      }
    })();

    return (
      <Wrapper
        windowHeight={windowHeight}
        top={Sizes.getMenuTopPadding(windowWidth)}
        menuWidth={Sizes.getMenuWidth(windowWidth)}
        innerRef={this.registerRef}
        style={{ transform: `translateX(-600px) translateZ(0px)`, opacity: mounted ? 1 : 0 }}
      >
        <Scrollbars autoHide={true} style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }}>
          <InnerWrapper>
            <MenuContent windowWidth={windowWidth} adminBarHeight={adminBarHeight} />
          </InnerWrapper>
        </Scrollbars>
      </Wrapper>
    );
  }

  componentWillUnmount() {
    if (this.activeAction && this.activeAction.stop) {
      this.activeAction.stop();
    }
  }

  private registerRef(wrapper: HTMLElement | null) {
    if (wrapper) {
      this.wrapperRef = wrapper;
      if (this.wrapperRef) {
        this.elemStyler = styler(this.wrapperRef, {});
      }
    }
  }

  private applyTranslateValue(values: AnimatedValues) {
    if (this.elemStyler) {
      this.elemStyler.set(values);
    }
  }

  private getMenuTranslate(nextProps?: Props): number {
    const props = nextProps || this.props;
    if (props.mounted === false) {
      return -Sizes.getMenuWidth(props.windowWidth) * 0.3;
    }
    const layout = Sizes.getMenuLayout(props.windowWidth);
    return props.open || layout === Sizes.MenuLayout.Desktop ? 0 : -Sizes.getMenuWidth(props.windowWidth);
  }
}



// WEBPACK FOOTER //
// ./src/module/View/Menu/MenuWrapper.tsx